module.exports = __webpack_public_path__ + "static/media/DroneControlCenter.ea7c2fe1.svg";